// Module
var code = `<inline-panel on-hide="\$ctrl.onHide()"
              ng-if="\$ctrl.getFees(\$ctrl.amortization.lineNumber).length > 0 || \$ctrl.feeDefinitions.length > 0"
              flex-row="true"
              ng-click="\$ctrl.disableAdd()">
  <div class="inline-panel__container--row"
       ng-repeat="fee in \$ctrl.getFees(\$ctrl.amortization.lineNumber)">
    <div>
      <p class="inline-panel__label">
        {{ fee.name }}
        <i class="icon icon-remove" ng-if="!fee.id"
                                   ng-click="\$ctrl.deleteCustomFee(fee)"
                                   title="Delete custom fee">
        </i>
      </p>

      <div class="input-cell">
        <cash min="0"
              max="fee.amount"
              ng-model="fee.balance"
              ng-change="\$ctrl.updateAmortization(\$ctrl.amortization.lineNumber)"
              ng-required="true"
              hide-currency="true"></cash>
        <span class="out-of">/</span>
        <cash min="0"
              ng-model="fee.amount"
              ng-change="\$ctrl.updateAmortization(\$ctrl.amortization.lineNumber)"
              ng-required="true"
              hide-currency="true"></cash>
      </div>
    </div>
  </div>
  <div class="inline-panel__container--row" ng-if="\$ctrl.addEnabled" ng-click="\$ctrl.stopPropagation(\$event)">
    <p class="inline-panel__label">
      Add custom fee:
    </p>
    <div class="input-cell custom-fee-input">
      <selectize options="\$ctrl.allowedFeeDefinitions"
                 config="\$ctrl.selectConfig"
                 ng-model="\$ctrl.feeDefinitionId"
                 ng-change="\$ctrl.addCustomFee()"
                 ng-required="true">

      </selectize>
    </div>
  </div>
  <div class="inline-panel__container--row custom-fee-button">
    <button class="btn btn-primary"
            ng-click="\$ctrl.enableAdd(\$event)"
            ng-if="!\$ctrl.addEnabled"
            title="Add custom fee">
      Add custom fee
    </button>
  </div>
</inline-panel>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/amortization/amortization-custom-fees-inline-panel.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;